module.exports = __webpack_public_path__ + "media/src/images/icons/credit_cards/jcb-e2155d04f307ac6aa65b655f3e539403.gif";